import React from "react";
import ApprovalWorkflowView from "./ApprovalWorkflowView";

export default function ApprovalEditSubmitView(props) {
  return <ApprovalWorkflowView {...props} mode="edit" />;
}
